import { useEffect, useState } from "react";

export interface ResponsiveLayout {
  compact: boolean;
  coarsePointer: boolean;
  narrow: boolean;
  short: boolean;
}

function readLayout(): ResponsiveLayout {
  if (typeof window === "undefined" || typeof window.matchMedia !== "function") {
    return { compact: false, coarsePointer: false, narrow: false, short: false };
  }
  const narrow = window.matchMedia("(max-width: 760px)").matches;
  const short = window.matchMedia("(max-height: 649px)").matches;
  const coarsePointer = window.matchMedia("(pointer: coarse)").matches;
  return { compact: narrow || short || coarsePointer, coarsePointer, narrow, short };
}

export function useResponsiveLayout(): ResponsiveLayout {
  const [layout, setLayout] = useState(readLayout);

  useEffect(() => {
    if (typeof window.matchMedia !== "function") return;
    const queries = [
      window.matchMedia("(max-width: 760px)"),
      window.matchMedia("(max-height: 649px)"),
      window.matchMedia("(pointer: coarse)"),
    ];
    const update = () => setLayout(readLayout());
    for (const query of queries) query.addEventListener("change", update);
    return () => {
      for (const query of queries) query.removeEventListener("change", update);
    };
  }, []);

  return layout;
}
